/**
 * is :: * -> Boolean
 *
 * @param {*} x
 * @return {boolean}
 * @see https://developer.mozilla.org/en-US/docs/Glossary/Truthy
 */
export const is = x => !!x;
